/**
 * Kronik Bricks — Kit Selector
 * Vanilla JS | Compatível com Impact 6.5.0
 * Todos os textos em alemão | Cores alinhadas ao tema da loja
 */

(function () {
  "use strict";

  // ─── Constantes ─────────────────────────────────────────────────────────────
const KIT_SIZE = 3;
const KIT_DISCOUNT_PERCENT = 34;

function calcKitPrice(products) {
  var total = products.reduce(function(sum, p) { return sum + p.price; }, 0);
  return Math.round(total * (1 - KIT_DISCOUNT_PERCENT / 100));
}

function calcKitOriginalPrice(products) {
  return products.reduce(function(sum, p) { return sum + p.price; }, 0);
}

  // ─── Dados dos produtos (ordenados por preço) ────────────────────────────────
  const PRODUCTS = [
    // €149
    { id: 14997610430831, title: "SF24 (1361 Teile)", variantId: 53120608928111, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_9_products_29.jpg" },
    { id: 14997610201455, title: "RB20 (1639 Teile)", variantId: 53120607846767, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_8_products_31.jpg" },
    { id: 14997609906543, title: "Panigale V4 R (646 Teile)", variantId: 53120604275055, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_7_products_17.jpg" },
    { id: 14997609677167, title: "One:1 – Modellbausatz (1505 Teile)", variantId: 53120602866031, price: 149, compareAtPrice: null, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_6_products_9.jpg" },
    { id: 14997609546095, title: "Mustang (1471 Teile)", variantId: 53120602571119, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_5_products_20.jpg" },
    { id: 14997608989039, title: "MT-10SP (1478 Teile)", variantId: 53120600703343, price: 149, compareAtPrice: null, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_4_products_30.jpg" },
    { id: 14997608661359, title: "MCL Racing (1432 Teile)", variantId: 53120599228783, price: 149, compareAtPrice: null, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_3_products_1.jpg" },
    { id: 14997606105455, title: "M4 GT3 (1494 Teile)", variantId: 53120584614255, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_29_products_14.jpg" },
    { id: 14997604794735, title: "M 1000 RR (1920 Teile)", variantId: 53120577438063, price: 149, compareAtPrice: 299, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_28_products_8.jpg" },
    { id: 14997604073839, title: "Intensa Emozione (1392 Teile)", variantId: 53120573833583, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_27_products_12.jpg" },
    { id: 14997603090799, title: "H.Davidson Black Rod (623 Teile)", variantId: 53120571343215, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_26_3.jpg" },
    { id: 14997602894191, title: "H.Davidson (634 Teile)", variantId: 53120569049455, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_25_2.jpg" },
    { id: 14997602369903, title: "H.Davidson (586 Teile)", variantId: 53120568525167, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_24_1_b47c27b8-6e22-4b88-9a7e-dd8f44683d7b.jpg" },
    { id: 14997601714543, title: 'GT-R "Gran Turismo" (1209 Teile)', variantId: 53120567771503, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_23_products_26.jpg" },
    { id: 14997601452399, title: "GT (1468 Teile)", variantId: 53120567312751, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_22_products_19.jpg" },
    { id: 14997600076143, title: "F-150 (1379 Teile)", variantId: 53120565707119, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_20_products_33.jpg" },
    { id: 14997598667119, title: 'DB5 "007" (1295 Teile)', variantId: 53120563478895, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_18_products_13.jpg" },
    { id: 14997595881839, title: "CVTT 1953 (1210 Teile)", variantId: 53120558530927, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_16_products_16.jpg" },
    { id: 14997595193711, title: "Charger 1970 (1077 Teile)", variantId: 53120557187439, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_14_products_6.jpg" },
    { id: 14997594800495, title: "Camaro Vintage (1454 Teile)", variantId: 53120556761455, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_13_products_15.jpg" },
    { id: 14997594374511, title: "9x8 LeMan Hybrid Hypercar (1775 Teile)", variantId: 53120556138863, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_11_products_32.jpg" },
    { id: 14997594210671, title: "911 Targa (1458 Teile)", variantId: 53120555188591, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_10_products_28.jpg" },
    { id: 14997593981295, title: "911 RSR Blau-Orange (1580 Teile)", variantId: 53120554959215, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_9_products_27.jpg" },
    { id: 14997593686383, title: "911 RSR (1580 Teile)", variantId: 53120554565999, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_8_products_4.jpg" },
    { id: 14997593063791, title: "488 GTE (1677 Teile)", variantId: 53120553550191, price: 149, compareAtPrice: 229.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_6_products_18.jpg" },
    { id: 14994295128431, title: "AMG F1 W14 (1642 Teile)", variantId: 53116385984879, price: 149, compareAtPrice: 249, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/products_5.png" },
    // €199
    { id: 14997593293167, title: "911 GT3 RS – Modellbausatz (2704 Teile)", variantId: 53120554074479, price: 199, compareAtPrice: null, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_7_products_10.jpg" },
    // €249
    { id: 14997610561903, title: "Sián FKP 37 – Modellbausatz (3696 Teile)", variantId: 53120609124719, price: 249, compareAtPrice: null, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_10_products_11.jpg" },
    { id: 14997608169839, title: "MCL P1 (3893 Teile)", variantId: 53120596869487, price: 249, compareAtPrice: 449.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_2_products_7.jpg" },
    { id: 14997600731503, title: "G 500 (2891 Teile)", variantId: 53120566526319, price: 249, compareAtPrice: null, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_21_products_25.jpg" },
    { id: 14997599388015, title: "Defender (2573 Teile)", variantId: 53120564789615, price: 249, compareAtPrice: null, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_19_products_24.jpg" },
    { id: 14997596897647, title: "Daytona SP3 (3778 Teile)", variantId: 53120560103791, price: 249, compareAtPrice: 449.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_17_products_2.jpg" },
    { id: 14997595488623, title: "Chiron (3599 Teile)", variantId: 53120557613423, price: 249, compareAtPrice: 449.99, image: "https://cdn.shopify.com/s/files/1/0978/7686/9487/files/imgi_15_products_3.jpg" },
  ];

  // ─── State ───────────────────────────────────────────────────────────────────
  let selected = []; // array of product objects (max 3)
  let isLoading = false;

  // ─── DOM refs ────────────────────────────────────────────────────────────────
  let progressFill, progressLabel, gridContainer, cartSlots, cartDots, cartCount, cartBtn, errorBanner;
let cartPriceEl, cartPriceOriginalEl, cartPriceDiscountEl;

  // ─── Init ────────────────────────────────────────────────────────────────────
  function init() {
    const root = document.getElementById("kronik-kit-root");
    if (!root) return;

    progressFill  = root.querySelector(".kronik-kit__progress-fill");
    progressLabel = root.querySelector(".kronik-kit__progress-label");
    gridContainer = root.querySelector(".kronik-kit__grids");
    cartSlots     = root.querySelectorAll(".kronik-kit__slot");
    cartDots      = root.querySelectorAll(".kronik-kit__cart-dot");
    cartCount     = root.querySelector(".kronik-kit__cart-count");
    cartBtn       = root.querySelector(".kronik-kit__cart-btn");
    cartPriceEl         = document.querySelector("#kronik-kit-root .kronik-kit__cart-price");
cartPriceOriginalEl = document.querySelector("#kronik-kit-root .kronik-kit__cart-price-original");
cartPriceDiscountEl = document.querySelector("#kronik-kit-root .kronik-kit__cart-price-discount");
    errorBanner   = root.querySelector(".kronik-kit__error");

    buildGrid();
    bindCartBtn();
    render();
  }

  // ─── Build product grid ──────────────────────────────────────────────────────
  function buildGrid() {
    if (!gridContainer) return;
    gridContainer.innerHTML = "";

    const groups = [249, 199, 149];
    groups.forEach(function (price) {
      const group = PRODUCTS.filter(function (p) { return p.price === price; });
      if (!group.length) return;

      const section = document.createElement("div");
      section.className = "kronik-kit__group";

      // Divider
      section.innerHTML =
        '<div class="kronik-kit__group-divider">' +
          '<div class="kronik-kit__group-line"></div>' +
          '<span class="kronik-kit__group-label">€' + price + ' pro Modell</span>' +
          '<div class="kronik-kit__group-line"></div>' +
        '</div>';

      const grid = document.createElement("div");
      grid.className = "kronik-kit__grid";

      group.forEach(function (product) {
        const card = buildCard(product);
        grid.appendChild(card);
      });

      section.appendChild(grid);
      gridContainer.appendChild(section);
    });
  }

  // ─── Build single card ───────────────────────────────────────────────────────
  function buildCard(product) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "kronik-kit__card";
    btn.dataset.productId = String(product.id);

    btn.innerHTML =
      // Price badge
      '<span class="kronik-kit__card-price-badge">€' + product.price + '</span>' +
      // Selection badge (hidden by default)
      '<span class="kronik-kit__card-badge" style="display:none"></span>' +
      // Image
      '<div class="kronik-kit__card-img-wrap">' +
        '<img class="kronik-kit__card-img" src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" />' +
        '<div class="kronik-kit__card-overlay" style="display:none">' +
          '<div class="kronik-kit__card-check">' +
            '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"></polyline></svg>' +
          '</div>' +
        '</div>' +
      '</div>' +
      // Info
      '<div class="kronik-kit__card-info">' +
        '<p class="kronik-kit__card-name">' + escapeHtml(product.title) + '</p>' +
        (product.compareAtPrice ? '<p class="kronik-kit__card-compare">€' + product.compareAtPrice.toFixed(2) + '</p>' : '') +
      '</div>';

    btn.addEventListener("click", function () { toggleProduct(product); });
    return btn;
  }

  // ─── Toggle product selection ────────────────────────────────────────────────
  function toggleProduct(product) {
    if (isLoading) return;
    const idx = selected.findIndex(function (p) { return p.id === product.id; });
    if (idx !== -1) {
      selected.splice(idx, 1);
    } else {
      if (selected.length >= KIT_SIZE) return;
      selected.push(product);
    }
    render();
  }

  // ─── Remove from cart ────────────────────────────────────────────────────────
  function removeProduct(productId) {
    selected = selected.filter(function (p) { return p.id !== productId; });
    render();
  }

  // ─── Render all UI ───────────────────────────────────────────────────────────
  function render() {
    const count = selected.length;
    const isFull = count >= KIT_SIZE;
    const isReady = count === KIT_SIZE;

    // Progress bar
    if (progressFill) progressFill.style.width = ((count / KIT_SIZE) * 100) + "%";
    if (progressLabel) progressLabel.textContent = count + " von " + KIT_SIZE + " ausgewählt";

    // Cards
    const allCards = document.querySelectorAll(".kronik-kit__card");
    allCards.forEach(function (card) {
      const id = Number(card.dataset.productId);
      const selIdx = selected.findIndex(function (p) { return p.id === id; });
      const isSelected = selIdx !== -1;
      const badge = card.querySelector(".kronik-kit__card-badge");
      const overlay = card.querySelector(".kronik-kit__card-overlay");

      card.classList.toggle("kronik-kit__card--selected", isSelected);
      card.classList.toggle("kronik-kit__card--disabled", isFull && !isSelected);
      card.disabled = isFull && !isSelected;

      if (badge) {
        badge.style.display = isSelected ? "flex" : "none";
        badge.textContent = isSelected ? String(selIdx + 1) : "";
      }
      if (overlay) {
        overlay.style.display = isSelected ? "flex" : "none";
      }
    });

    // Cart dots
    if (cartDots) {
      cartDots.forEach(function (dot, i) {
        dot.classList.toggle("kronik-kit__cart-dot--filled", i < count);
      });
    }
    if (cartCount) cartCount.textContent = count + "/" + KIT_SIZE;

    // Cart slots
    if (cartSlots) {
      cartSlots.forEach(function (slot, i) {
        const product = selected[i] || null;
        if (product) {
          slot.innerHTML =
            '<div class="kronik-kit__slot-filled">' +
              '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" />' +
              '<button type="button" class="kronik-kit__slot-remove" data-remove-id="' + product.id + '" aria-label="' + escapeHtml(product.title) + ' entfernen">' +
                '<svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
              '</button>' +
            '</div>';
          const removeBtn = slot.querySelector(".kronik-kit__slot-remove");
          if (removeBtn) {
            removeBtn.addEventListener("click", function (e) {
              e.stopPropagation();
              removeProduct(Number(removeBtn.dataset.removeId));
            });
          }
        } else {
          slot.innerHTML =
            '<div class="kronik-kit__slot-empty">' +
              '<span class="kronik-kit__slot-num">' + (i + 1) + '</span>' +
            '</div>';
        }
      });
    }

    // Cart button
    if (cartBtn) {
      cartBtn.disabled = !isReady || isLoading;
      cartBtn.classList.toggle("kronik-kit__cart-btn--ready", isReady && !isLoading);
      if (isLoading) {
        cartBtn.innerHTML = '<span class="kronik-kit__spinner"></span> Wird geladen…';
      } else {
        cartBtn.innerHTML =
          '<svg viewBox="0 0 24 24" style="width:1rem;height:1rem;stroke:currentColor;fill:none;stroke-width:2">' +
            '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle>' +
            '<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>' +
          '</svg>' +
          'Kit kaufen' +
          '<svg viewBox="0 0 24 24" style="width:0.75rem;height:0.75rem;stroke:currentColor;fill:none;stroke-width:2.5">' +
            '<polyline points="9 18 15 12 9 6"></polyline>' +
          '</svg>';
      }

    // Cart price
    if (cartPriceEl) {
      if (isReady) {
        var origPrice = calcKitOriginalPrice(selected);
        var kitPrice  = calcKitPrice(selected);
        cartPriceEl.textContent = "€" + kitPrice;
        if (cartPriceOriginalEl) {
          cartPriceOriginalEl.textContent = "€" + origPrice;
          cartPriceOriginalEl.style.display = "block";
        }
        if (cartPriceDiscountEl) {
          cartPriceDiscountEl.textContent = "-48%";
          cartPriceDiscountEl.style.display = "block";
        }
      } else {
        cartPriceEl.textContent = "€—";
        if (cartPriceOriginalEl) cartPriceOriginalEl.style.display = "none";
        if (cartPriceDiscountEl) cartPriceDiscountEl.style.display = "none";
      }
    }


    }
  }

  // ─── Cart button click ───────────────────────────────────────────────────────
  function bindCartBtn() {
    if (!cartBtn) return;
    cartBtn.addEventListener("click", async function () {
      if (selected.length < KIT_SIZE || isLoading) return;
      isLoading = true;
      render();
      hideError();

      try {
        const items = selected.map(function (p) {
          return { id: p.variantId, quantity: 1, properties: { _kit: "kronik-kit-3" } };
        });

        const res = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items }),
        });

        if (!res.ok) {
          const data = await res.json().catch(function () { return {}; });
          throw new Error(data.description || "Fehler beim Hinzufügen zum Warenkorb.");
        }

        const checkoutLink = document.createElement("a");
checkoutLink.href = "/checkout";
checkoutLink.style.display = "none";
document.body.appendChild(checkoutLink);
checkoutLink.click();
document.body.removeChild(checkoutLink);
      } catch (err) {
        showError(err.message || "Fehler beim Hinzufügen zum Warenkorb. Bitte versuche es erneut.");
        isLoading = false;
        render();
      }
    });
  }

  // ─── Error helpers ───────────────────────────────────────────────────────────
  function showError(msg) {
    if (!errorBanner) return;
    const msgEl = errorBanner.querySelector(".kronik-kit__error-msg");
    if (msgEl) msgEl.textContent = msg;
    errorBanner.style.display = "flex";
  }

  function hideError() {
    if (errorBanner) errorBanner.style.display = "none";
  }

  // ─── Utility ────────────────────────────────────────────────────────────────
  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  // ─── Bootstrap ──────────────────────────────────────────────────────────────
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
